/* eslint-disable sort-keys */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-cycle */
import React from 'react'

import UspImage from '../../assets/images/invite.jpg'
import { Image } from '../../components'
import { Content } from '../../components/Typography'
import { SectionContainer } from '../../layouts'
import {
  contentContainer,
  experienceContent,
  experienceContentContainer,
  experienceImage,
  experienceImageContainer,
  experienceItem,
  experienceItemsContainer,
  experienceItemTitle,
  extraKickerStyling,
  // reverseImage,
  sectionColor,
} from './MothersDayUsp.module.css'

const MothersDayUsp = () => {
  const experiencekicker = 'Where & How to Pick Up Your Gift'
  const uspcontent = `Come by our clinic at Statenplein 21 to collect your gift card — beautifully wrapped and ready to be gifted.

No extra effort — just an elegant surprise she’ll love.

Wrapped, Ready, and Waiting for Her 💝
`

  return (
    <SectionContainer
      extraClassName={sectionColor}
      extraContentClassName={contentContainer}
      extraHeadingClassName={extraKickerStyling}
      withHeader
    >
      <div className={experienceItemsContainer}>
        <div className={`${experienceItem}`}>
          <div className={experienceContentContainer}>
            <p className={experienceItemTitle}>{experiencekicker}</p>
            <Content
              extraClassName={experienceContent}
              renderContent={uspcontent}
            />
          </div>
          <div className={experienceImageContainer}>
            <Image
              alt="Kliniken Image"
              className={experienceImage}
              loading="lazy"
              quality={85}
              src={UspImage}
            />
          </div>
        </div>
      </div>
    </SectionContainer>
  )
}

export default MothersDayUsp
